// The Program panel (Oct 2026): an area's progress through the ten program
// steps, for moderators on the desktop map. Two flags, so the AI half can go
// dark on its own.
//
// PROGRAM_PANEL_ENABLED: the rail button and the panel. Off hides both.
// AREA_BRIEF_ENABLED: the weekly brief under the step strip, which calls the
// generateAreaBrief Cloud Function (one model call per area per week). Off
// hides the brief, its next moves and Generate/Regenerate; the strip stays,
// since it is computed in the browser from data the map already loads.
export const PROGRAM_PANEL_ENABLED = true;
export const AREA_BRIEF_ENABLED = true;

/** The audit fixture plan's area (Oct 2026). Not a service area, so no area
 *  query in a real community sees the fixture; see useProgramAreaId. */
export const AUDIT_FIXTURE_AREA_ID = 'audit-fixture';

/** The panel heading's id, shared by the dock in app/(tabs)/index.tsx and
 *  the lazily loaded body that renders the heading. */
export const PROGRAM_PANEL_HEADING_ID = 'program-panel-heading';
